import { c as _c } from "react/compiler-runtime";
import React, { FC, SVGProps } from 'react';
export const Check: FC<SVGProps<SVGSVGElement>> = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g id="title=tick"><path id="Stroke 4" d="M6 11.9994L10.0011 15.9989L18 8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg {...props} fill="none" stroke="currentColor" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};